import React, { Component } from 'react';
//import Header from '../../../Header';
import Header from '../../../Header'
import MessageLink from '../../../MessageLink';
import Footer from '../../../Footer';
import PageDescription from '../../../PageDescription';
import Patrimonio from '../../../Numeros/Patrimonio';
import BannerSingle from '../../../BannerSingle';
import Beneficios from '../../../Numeros/Beneficios';
import Vidas from '../../../Numeros';
import Lgpd from '../../../Lgpd';
import ErrorBoundary from '../../../ErrorHandler/ErrorBoundary';

class Numeros extends Component {
	render() {
		return (
			<div>
				{/* HEADER */}{/* LOGIN */}
				<ErrorBoundary><Header /></ErrorBoundary>
				<ErrorBoundary><BannerSingle image={"numeros"} page={'numeros'} /></ErrorBoundary>
				{/* Page description */}
				<ErrorBoundary><PageDescription page={'numeros'} /></ErrorBoundary>
				{/* Content page */}
				<div className="_the-content page-numeros pb-10">
					<div className="container">
						<ErrorBoundary><Patrimonio /></ErrorBoundary>
						<div className="col-lg-10">
							<ErrorBoundary><Vidas /></ErrorBoundary>
							<ErrorBoundary><Beneficios /></ErrorBoundary>
						</div>
					</div>
				</div>
				{/* FOOTER */}
				<ErrorBoundary><Footer /></ErrorBoundary>
				{/* Message Link */}
				<ErrorBoundary><MessageLink /></ErrorBoundary>
				{/* LGPD */}
				<ErrorBoundary><Lgpd /></ErrorBoundary>

			</div>
		);
	}
};

export default Numeros;